(function () {
  'use strict';

  var mobileQuery = window.matchMedia('(max-width: 767px)');

  function unique(elements) {
    return elements.filter(function (element, index, list) {
      return element && list.indexOf(element) === index;
    });
  }

  function dropdowns() {
    return unique(Array.prototype.slice.call(document.querySelectorAll(
      '[data-mn-collection-dropdown], .mn-category-navigation__mobile .w-dropdown, .collection-mobile .w-dropdown'
    )));
  }

  function getToggle(dropdown) {
    return dropdown ? dropdown.querySelector('[data-mn-collection-toggle], .w-dropdown-toggle') : null;
  }

  function getList(dropdown) {
    return dropdown ? dropdown.querySelector('[data-mn-collection-list], .w-dropdown-list') : null;
  }

  function setDropdownState(dropdown, open) {
    if (!dropdown) return;

    var toggle = getToggle(dropdown);
    var list = getList(dropdown);

    dropdown.classList.toggle('is-open', open);
    dropdown.classList.toggle('w--open', open);
    dropdown.setAttribute('data-mn-open', open ? 'true' : 'false');

    if (toggle) {
      toggle.classList.toggle('w--open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    if (list) {
      list.classList.toggle('w--open', open);
      list.setAttribute('aria-hidden', open ? 'false' : 'true');
      list.style.display = open ? 'block' : 'none';
      list.style.opacity = open ? '1' : '0';
      list.style.visibility = open ? 'visible' : 'hidden';
      list.style.pointerEvents = open ? 'auto' : 'none';
    }
  }

  function closeCollectionDropdowns(except) {
    dropdowns().forEach(function (dropdown) {
      if (dropdown !== except) setDropdownState(dropdown, false);
    });
  }

  function closeShopAccordions() {
    document.querySelectorAll('.mn-shop-menu__group').forEach(function (group) {
      group.classList.remove('is-open');
      var trigger = group.querySelector('.mn-shop-menu__group-summary');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    });
  }

  function shopOverlay() {
    return document.querySelector('.nav-overlay .mn-shop-menu')
      ? document.querySelector('.nav-overlay')
      : null;
  }

  function overlayIsOpen(overlay) {
    if (!overlay) return false;
    var style = window.getComputedStyle(overlay);
    return style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0';
  }

  function syncShopState() {
    var overlay = shopOverlay();
    var open = overlayIsOpen(overlay);
    document.body.classList.toggle('mn-shop-menu-open', open);
    if (open) closeCollectionDropdowns();
  }

  function resetBeforeDirectNavigation() {
    closeCollectionDropdowns();
    closeShopAccordions();
    document.body.classList.remove('mn-shop-menu-open');
  }

  document.addEventListener('click', function (event) {
    if (!mobileQuery.matches) return;

    var toggle = event.target.closest('[data-mn-collection-toggle], .collection-mobile .w-dropdown-toggle');
    if (toggle) {
      var dropdown = toggle.closest('[data-mn-collection-dropdown], .w-dropdown');
      var willOpen = dropdown && !dropdown.classList.contains('is-open');

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      closeCollectionDropdowns(dropdown);
      setDropdownState(dropdown, willOpen);
      return;
    }

    var directShopLink = event.target.closest(
      '.mn-shop-menu__mobile-link--sale, .mn-shop-menu__mobile-link--store, .mn-shop-menu__mobile-links a, .mn-shop-menu a[href*="/collections/sale"]'
    );
    if (directShopLink) {
      resetBeforeDirectNavigation();
      return;
    }

    var shopControl = event.target.closest('.burger, .shop-popup, .mn-shop-menu__group-summary, .mn-shop-menu__close');
    if (shopControl) {
      closeCollectionDropdowns();
      window.setTimeout(syncShopState, 0);
      window.setTimeout(syncShopState, 480);
      return;
    }

    var categoryLink = event.target.closest('[data-mn-collection-list] a, .collection-mobile .w-dropdown-list a');
    if (categoryLink) {
      closeCollectionDropdowns();
      return;
    }

    if (!event.target.closest('.mn-category-navigation__mobile, .collection-mobile')) {
      closeCollectionDropdowns();
    }
  }, true);

  window.addEventListener('pageshow', function () {
    resetBeforeDirectNavigation();
    window.setTimeout(syncShopState, 0);
  });

  window.addEventListener('popstate', function () {
    resetBeforeDirectNavigation();
  });

  mobileQuery.addEventListener && mobileQuery.addEventListener('change', function () {
    resetBeforeDirectNavigation();
    syncShopState();
  });

  function initialise() {
    closeCollectionDropdowns();

    var overlay = shopOverlay();
    if (overlay && window.MutationObserver) {
      new MutationObserver(syncShopState).observe(overlay, {
        attributes: true,
        attributeFilter: ['class', 'style', 'aria-hidden']
      });
    }

    syncShopState();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialise);
  } else {
    initialise();
  }
})();
